import React from 'react';
import PropTypes from 'prop-types';

export const FetchButton = (props) => {
    return (
        <div className="col-sm-12">
            <button className="btn btn-info" onClick={props.clickSubmit}>Submit</button>
        </div>
    )
}

FetchButton.PropTypes = {
    fetch: PropTypes.func
}







// WEBPACK FOOTER //
// ./src/components/FetchButton.js